import React from "react";
import OPOnIframe from "pages/iframe-component/operation-online/OPOnIframe";
import usePageState from "utils/usePageState";

const OnlineEmployeeDetailIframe = ({ path }) => {
  const { pageState } = usePageState({ pagePath: path });
  const employeeId = pageState.employeeId;

  // uses /merchant/list with merchantIdRedirect query parameter to redirect into merchant/info with the desired merchantId
  const urlPath = `/online-pay/employee/employee-list${employeeId ? "?employeeIdRedirect=" + employeeId : ""
    }`;

  return <OPOnIframe path={urlPath} />;
};

export default React.memo(OnlineEmployeeDetailIframe);
